// js-cookie v3.0.5 | MIT
!(function (e, t) {
	"object" == typeof exports && "undefined" != typeof module
		? (module.exports = t())
		: "function" == typeof define && define.amd
		? define(t)
		: ((e = "undefined" != typeof globalThis ? globalThis : e || self),
		  (function () {
			  var n = e.Cookies,
				  o = (e.Cookies = t());
			  o.noConflict = function () {
				  return (e.Cookies = n), o;
			  };
		  })());
})(this, function () {
	"use strict";
	function e(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var o in n) e[o] = n[o];
		}
		return e;
	}
	var t = (function t(n, o) {
		function r(t, r, i) {
			if ("undefined" != typeof document) {
				"number" == typeof (i = e({}, o, i)).expires &&
					(i.expires = new Date(Date.now() + 864e5 * i.expires)),
					i.expires && (i.expires = i.expires.toUTCString()),
					(t = encodeURIComponent(t)
						.replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
						.replace(/[()]/g, escape));
				var c = "";
				for (var u in i)
					i[u] &&
						((c += "; " + u),
						!0 !== i[u] && (c += "=" + i[u].split(";")[0]));
				return (document.cookie = t + "=" + n.write(r, t) + c);
			}
		}
		return Object.create(
			{
				set: r,
				get: function (e) {
					if (
						"undefined" != typeof document &&
						(!arguments.length || e)
					) {
						for (
							var t = document.cookie
									? document.cookie.split("; ")
									: [],
								o = {},
								r = 0;
							r < t.length;
							r++
						) {
							var i = t[r].split("="),
								c = i.slice(1).join("=");
							try {
								var u = decodeURIComponent(i[0]);
								if (((o[u] = n.read(c, u)), e === u)) break;
							} catch (e) {}
						}
						return e ? o[e] : o;
					}
				},
				remove: function (t, n) {
					r(t, "", e({}, n, { expires: -1 }));
				},
				withAttributes: function (n) {
					return t(this.converter, e({}, this.attributes, n));
				},
				withConverter: function (n) {
					return t(e({}, this.converter, n), this.attributes);
				},
			},
			{
				attributes: { value: Object.freeze(o) },
				converter: { value: Object.freeze(n) },
			}
		);
	})(
		{
			read: function (e) {
				return (
					'"' === e[0] && (e = e.slice(1, -1)),
					e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
				);
			},
			write: function (e) {
				return encodeURIComponent(e).replace(
					/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
					decodeURIComponent
				);
			},
		},
		{ path: "/" }
	);
	return t;
});

const tfs = {};

tfs.util = {
	log(message) {
		console.log(`%c${message}`, "color: blue; font-weight: bold;");
	},
	add_script(url, defer) {
		var script = document.createElement("script");
		script.src = url;
		if (defer) script.defer = true;
		document.head.appendChild(script);
	},
	add_stylesheet(url) {
		var link = document.createElement("link");
		link.href = url;
		link.rel = "stylesheet";
		document.head.appendChild(link);
	},
	error: {
		report(err) {
			if (typeof Sentry === "undefined") return;

			if (
				location.host.includes("dev") ||
				location.host.includes("localhost")
			) {
				console.error(err);
			} else {
				Sentry.captureException(err);
			}
		},
	},
	checkDomain(url) {
		if (url.includes("tfs.services")) return true;
		if (url.includes("-api.truefire.com")) return true;
		if (url.includes("/tfs/api/")) return true;
		if (url.includes("/tfs/nexus/")) return true;
		if (url.includes("-services.truefire.com")) return true;
		if (url.includes("localhost:8082")) return true;
		return false;
	},
	api: {
		url() {
			switch (true) {
				case location.host.includes(".dev"):
					console.log('updating api url because of.dev in location.host to localhost:8082')
					return "http://localhost:8082";
				case location.host.includes("localhost"):
					console.log('updating api url because of localhost in location.host to localhost:8082')
					return "http://localhost:8082";
				default:
					return `${location.protocol}//${location.host}`;
			}
		},
	},
	getUser() {
		let jwt = Cookies.get("jwt");

		if (!jwt) return {};

		try {
			// Extract the payload from the JWT
			const payload = jwt.split(".")[1];
			// Decode the payload using base64 decoding
			const decodedPayload = atob(payload);
			// Parse the decoded payload into a JSON object
			const jsonPayload = JSON.parse(decodedPayload);
			return jsonPayload.data;
		} catch (error) {
			return {};
		}
	},
	gtm: {
		push(gtmData) {
			window.dataLayer = window.dataLayer || [];
			if (Array.isArray(gtmData)) {
				gtmData.forEach((data) => {
					window.dataLayer.push(data);
				});
			} else {
				window.dataLayer.push(gtmData);
			}
		},
	},
	async makeRequest({
		url,
		method = "GET",
		data = null,
		onSuccess = () => {},
		onError = () => {},
	}) {
		try {
			// Check if axios is available
			if (typeof axios !== "undefined") {
				const response = await axios({
					method,
					url,
					data,
				});
				onSuccess(response.data, response.status);
				return response.data;
			} else {
				// Fallback to using fetch
				const options = {
					method,
					headers: { "Content-Type": "application/json" },
				};
				if (data) {
					options.body = JSON.stringify(data);
				}
				const response = await fetch(url, options);

				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}

				const responseData = await response.json();
				onSuccess(responseData, response.status);
				return responseData;
			}
		} catch (error) {
			if (error.response && error.response.status) {
				// Axios error with response status
				onError(error, error.response.status);
			} else {
				onError(error);
			}
			throw error;
		}
	},
};
class TFSUtils {
	constructor() {
		if (
			location.host.includes("dev.") ||
			location.host.includes("localhost")
		) {
		} else {
			this.doSentry();
		}

		this.doGTM();
		if (typeof axios !== "undefined") {
			try {
				this.doAxios();
			} catch (error) {
				tfs.util.error.report(error);
			}
		}
		if (window.jQuery) {
			try {
				this.dojQuery();
			} catch (error) {
				tfs.util.error.report(error);
			}
		}
		if (!window.$tfs) {
			window.$tfs = {};
		}
		window.$tfs.user = tfs.util.getUser();
		window.$tfs.util = tfs.util;
	}

	createAndDispatchEvent(eventName) {
		let event;
		if (typeof CustomEvent === 'function') {
			event = new CustomEvent(eventName);
		} else {
			event = document.createEvent('CustomEvent');
			event.initCustomEvent(eventName, false, false, null);
		}
	
		window.dispatchEvent(event);
	}

	doPartnerNonceAuthentication() {
		if (!tfs.util.checkDomain(window.location.href)) return;
		const urlParams = new URLSearchParams(window.location.search);
		if (!urlParams.has("partner-nonce")) {
			return;
		}

		const nonce = urlParams.get("partner-nonce");

		tfs.util.makeRequest({
			url: `${tfs.util.api.url()}/partnerships/request/user/for/nonce/${nonce}`,
			onSuccess: (response, response_code) => {
				if (response_code == 202) {
					let $message = `Welcome, TrueFire Student! An account with the email of ${response.obfuscated_email} already exists. Please connect your TrueFire and ${response.partner_name} accounts by entering the 5-character alphanumeric PIN that was sent to your email address. Thank you!`;

					this.showBootstrapPinModal({
						message: $message,
						form_key: response.key,
					});
				}

				if(response.player_configuration){
					this.addPlayerConfiguration(response.player_configuration)
				}
			},
			onError: (error, response_code) => {},
		});
	}

	addPlayerConfiguration($player_configuration) {

		let player_configuration = $player_configuration || {};

		if (!window.$tfs) {
			window.$tfs = {};
		}
		window.$tfs.player_configuration = player_configuration;
		this.createAndDispatchEvent('initialize-player')

	}

	showBootstrapPinModal(options = {}) {
		let feedbackElement;
		function createModalElement() {
			const modalDiv = document.createElement("div");
			modalDiv.classList.add("modal", "fade");
			modalDiv.setAttribute("id", "pinModal");
			modalDiv.setAttribute("tabindex", "-1");
			modalDiv.setAttribute("aria-labelledby", "pinModalLabel");
			modalDiv.setAttribute("aria-hidden", "true");
			return modalDiv;
		}

		function createModalHeader() {
			const header = document.createElement("div");
			header.classList.add("modal-header");
			const title = document.createElement("h5");
			title.classList.add("modal-title");
			title.setAttribute("id", "pinModalLabel");
			title.textContent = "Enter Your PIN";
			header.appendChild(title);
			return header;
		}

		function createFeedbackMessage() {
			const feedback = document.createElement("div");

			feedback.textContent =
				"Please enter a valid 5-character alphanumeric PIN.";
			return feedback;
		}

		function setFeedbackMessage(message) {
			if (feedbackElement) {
				feedbackElement.innerHTML = message ? message : ``;
			}
		}

		function handleResendClick(e) {
			console.log(options.form_key);
			e.preventDefault(); // Prevent default anchor action
			tfs.util.makeRequest({
				url: `${tfs.util.api.url()}/partnerships/request/email/resend/for/key/${
					options.form_key
				}`,
				onSuccess: (response, response_code) => {
					setFeedbackMessage(
						`<div class="mb-2">PIN resent. Having issues?&nbsp;&nbsp;<a href="mailto:help@truefire.com?subject=Martin Lesson Room" class="text-decoration-none">Contact us <i class="fas fa-angle-right"></i></a></div>`
					);
				},
			});
		}

		function validateAndSubmit() {
			// const pinValue = pinInputs.map((input) => input.value).join("");
			const pinValue = pinInput.value
			if (pinValue.length !== 5 || !/^[a-zA-Z0-9]+$/.test(pinValue)) {
				setFeedbackMessage(
					"Please enter a valid 5-character alphanumeric PIN."
				);
				// pinInputs.forEach((input) => {
				// 	input.classList.add("is-invalid");
				// });
				pinInput.classList.add("is-invalid");
			} else {
				// Submit logic goes here...
				tfs.util.makeRequest({
					url: `${tfs.util.api.url()}/partnerships/request/user/for/pin_key`,
					method: "POST",
					data: {
						key: options.form_key,
						pin: pinValue.toUpperCase(),
					},
					onSuccess: (response, response_code) => {
						//close modal
						modalInstance.hide();
					},
					onError: (error, error_code) => {
						setFeedbackMessage(error.response.data.message);
					},
				});

				// remove is-invalid class after successful validation
				// pinInputs.forEach((input) => {
				// 	input.classList.remove("is-invalid");
				// });
				pinInput.classList.remove("is-invalid");
			}
		}

		const modalDiv = createModalElement();
		const modalDialog = document.createElement("div");
		modalDialog.classList.add("modal-dialog");
		modalDiv.appendChild(modalDialog);

		const modalContent = document.createElement("div");
		modalContent.classList.add("modal-content");
		modalDialog.appendChild(modalContent);

		modalContent.appendChild(createModalHeader());

		const modalBody = document.createElement("div");
		modalBody.classList.add("modal-body");
		modalContent.appendChild(modalBody);

		const instructionText = document.createElement("p");
		instructionText.textContent = `${
			options.message ||
			"Please enter the 5-character alphanumeric PIN that was sent to your email address."
		}`;
		modalBody.appendChild(instructionText);

		// const pinInputs = [];

		// for (let i = 0; i < 5; i++) {
		// 	const pinInput = document.createElement("input");
		// 	pinInput.setAttribute("type", "text");
		// 	pinInput.setAttribute("maxlength", "1");
		// 	pinInput.classList.add("form-control", "d-inline", "mx-1");
		// 	pinInput.style.width = "40px";

		// 	pinInput.addEventListener("input", function () {
		// 		// remove is-invalid class upon user input
		// 		pinInput.classList.remove("is-invalid");
		// 		feedbackElement.textContent = "";

		// 		if (i < 4) {
		// 			pinInputs[i + 1].focus();
		// 		}

		// 		if (
		// 			i === 4 &&
		// 			pinInputs.every((input) => input.value.trim().length === 1)
		// 		) {
		// 			validateAndSubmit();
		// 		}
		// 	});
		// 	pinInputs.push(pinInput);
		// 	modalBody.appendChild(pinInput);
		// }

		// pinInputs[0].addEventListener("paste", function (event) {
		// 	// Get pasted data
		// 	const paste = (event.clipboardData || window.clipboardData).getData(
		// 		"text"
		// 	);

		// 	// If the pasted content is exactly 5 characters long
		// 	if (paste.length === 5) {
		// 		// Iterate over the pinInputs and set their values
		// 		for (let i = 0; i < pinInputs.length; i++) {
		// 			pinInputs[i].value = paste[i];
		// 		}
		// 	}
		// });

		const pinInput = document.createElement('input')
		pinInput.setAttribute("type", "text");
		pinInput.setAttribute("maxlength", "5");
		pinInput.classList.add("form-control", "d-block", 'mb-3');
		modalBody.appendChild(pinInput);



		feedbackElement = createFeedbackMessage();
		setFeedbackMessage(); // This initializes the default message
		modalBody.appendChild(feedbackElement);

		const modalFooter = document.createElement("div");
		modalFooter.classList.add("modal-footer");
		modalContent.appendChild(modalFooter);

		const resendLink = document.createElement("a");
		resendLink.href = "#";
		resendLink.textContent = "Resend PIN";
		resendLink.classList.add("text-decoration-none");
		resendLink.addEventListener("click", handleResendClick);
		modalBody.appendChild(resendLink);

		const submitButton = document.createElement("button");
		submitButton.classList.add("btn", "btn-primary");
		submitButton.innerText = "Submit";
		submitButton.onclick = validateAndSubmit;
		modalFooter.appendChild(submitButton);

		document.body.appendChild(modalDiv);

		let modalInstance = new bootstrap.Modal(modalDiv, {
			backdrop: "static",
			keyboard: false,
		});
		modalInstance.show();

		document.getElementById('pinModal').addEventListener('hidden.bs.modal', () => {
			if(Cookies){
				Cookies.remove('memberemail')
				Cookies.remove('auth_token')
				Cookies.remove('partner_id')
			}
			parent.location.reload()
		})
		
	}

	doSentry() {
		if (window.location.search.includes("nosentry=1")) return;

		function isSentrySupported() {
			// disable for video lesson pages with v# in the end of the URL
			if (/v\d+($|\?)/.test(window.location.href)) return false;

			//disabled for any player
			if (/player/i.test(window.location.href)) return false;

			let isMobileOrChromebook =
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|CrOS/i.test(
					navigator.userAgent
				);
			if (isMobileOrChromebook) {
				console.log(
					"Chromebook of mobile detected, not loading Sentry"
				);
				return false;
			}

			if (navigator.deviceMemory && navigator.deviceMemory < 2) {
				console.log(
					"Device has less than 2GB of RAM, not loading Sentry"
				);
				return false;
			}

			// Check supported browsers through userAgent
			let supportedBrowsers = /Chrome|Firefox|Safari|Edge|Opera/i;
			if (!supportedBrowsers.test(navigator.userAgent)) {
				console.log("Browser not supported by Sentry");
				return false;
			}

			// Check for XMLHttpRequest or Fetch API
			if (!("XMLHttpRequest" in window) && !("fetch" in window)) {
				console.log("XMLHttpRequest and Fetch API are not supported");
				return false;
			}

			// Check for window.onerror
			if (!("onerror" in window)) {
				console.log("window.onerror is not supported");
				return false;
			}

			// Check for Stack Trace API
			if (typeof Error.stackTraceLimit === "undefined") {
				console.log("Stack Trace API is not supported");
				return false;
			}

			// Check for Promise support
			if (!("Promise" in window)) {
				console.log("Promises are not supported");
				return false;
			}

			// Optional: Check for Web Worker support
			if (!("Worker" in window)) {
				console.log("Web Worker API is not supported");
				return false;
			}

			// Check for CORS support
			if (!("withCredentials" in new XMLHttpRequest())) {
				console.log("CORS is not supported");
				return false;
			}

			// Optional: Check for Local Storage support
			if (!("localStorage" in window)) {
				console.log("Local Storage is not supported");
				return false;
			}

			// Optional: Check for WebAssembly support
			if (!("WebAssembly" in window)) {
				console.log("WebAssembly is not supported");
				return false;
			}

			return true;
		}

		if (!isSentrySupported()) return; // If Sentry is not supported, exit the function

		if (typeof Sentry === "undefined") {
			let sentryScript = document.createElement("script");
			sentryScript.src =
				"https://js.sentry-cdn.com/af4ca35a7fee48279f32ccf5aab0dbab.min.js";
			sentryScript.crossOrigin = "anonymous";
			sentryScript.onload = function () {
				Sentry.init({
					sampleRate: 0.1,
				});
			};
			document.head.appendChild(sentryScript);
		}
	}

	doGTM() {
		const util = tfs.util;

		// Exit function if 'nogtm=1' is in the URL or if window.dataLayer is already defined.
		if (
			window.location.search.includes("nogtm=1") ||
			typeof window.dataLayer !== "undefined"
		)
			return;

		function doPHPAjax() {
			if (typeof phpajax === "undefined") return;

			if (phpajax.gtm_data) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({ meta: phpajax.gtm_data });
			}
		}

		/**
		 * Load the specified GTM container.
		 * @param {string} containerId - The ID of the GTM container to load.
		 */
		function loadGTM(containerId) {
			util.log(`Loaded ContainerId: ${containerId}`);
			if (!isGTMContainerLoaded(containerId)) return;

			if (!document || !document.head) return; // Safety check

			let scriptElement = document.createElement("script");
			scriptElement.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${containerId}');`;
			document.head.appendChild(scriptElement);
			startGtmContainer(containerId);
			window.dataLayer = window.dataLayer || [];
			doPHPAjax()
		}

		/**
		 * Start the specified GTM container by appending an iframe to the document body.
		 * @param {string} containerId - The ID of the GTM container to start.
		 */
		function startGtmContainer(containerId) {
			if (!document || !document.body) return; // Safety check

			let existingIframe = document.querySelector(
				'iframe[src="https://www.googletagmanager.com/ns.html?id=' +
					containerId +
					'"]'
			);
			if (!existingIframe) {
				let iframe = document.createElement("iframe");
				iframe.src =
					"https://www.googletagmanager.com/ns.html?id=" +
					containerId;
				iframe.height = 0;
				iframe.width = 0;
				iframe.style.display = "none";
				document.body.appendChild(iframe);
			}
		}

		/**
		 * Check if the specified GTM container is already loaded.
		 * @param {string} containerId - The ID of the GTM container to check.
		 * @return {boolean} - Returns true if the container is already loaded, otherwise false.
		 */
		function isGTMContainerLoaded(containerId) {
			let test;
			try {
				test = typeof window.google_tag_manager[containerId];
			} catch (error) {
				return true; // Consider revising this to handle errors more appropriately
			}
			return test ? true : false;
		}

		// Define GTM container IDs for specific hosts.
		let containers = [];
		if (location.host.includes("localhost")) containers.push("GTM-TJL3Q67");
		if (location.host.includes("truefire.com"))
			containers.push("GTM-WKLPZW9");
		if (location.host.includes("truefiregiveaways.com"))
			containers.push("GTM-WC4ZS8B");
		if (location.host.includes("jamplay.com")) containers.push("GTM-9MNC");
		
		//if gtm= is in the querystring load only that container
		let urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has("load_gtm_containers")) {
			containers = [];

			//the gtm could be a csv of container ids
			let gtm = urlParams.get("load_gtm_containers");
			if (gtm.includes(",")) {
				containers = gtm.split(",");
			} else {
				containers.push(gtm);
			}
		}

		// Load each GTM container for the current host.
		containers.forEach(function (container) {
			try {
				loadGTM(container);
			} catch (error) {
				console.error(error);
			}
		});
	}

	doAxios() {
		let util = tfs.util;
		function initAxios() {
			configAxios();
			doGTMPush();
			doCookiePush();
			doActionsPush();
			doJWT();
			doNexus();
			// updateRequestURLs()
			addJWTToAuthenticationHeader();
			addCookieToHeader("auth_token", "tf-token");
			addCookieToHeader("server_auth_token", "tf-token");
			addCookieToHeader("tfs_auth_token", "tf-token");
			addCookieToHeader("partner_id", "partner-id");
			addCookieToHeader("hubspotutk", "hubspotutk");
		}

		function addJWTToAuthenticationHeader() {
			axios.interceptors.request.use(
				(config) => {
					if (util.checkDomain(config.url)) {
						let cookie_data = Cookies.get("jwt");
						if (cookie_data) {
							config.headers[
								"Authorization"
							] = `Bearer ${cookie_data}`;
						}
					}
					return config;
				},
				(error) => {
					return Promise.reject(error);
				}
			);
		}

		function doJWT() {
			axios.interceptors.request.use(
				(config) => {
					if (util.checkDomain(config.url)) {
						let cookie_data = Cookies.get("jwt");
						if (cookie_data) {
							config.headers[
								"Authorization"
							] = `Bearer ${cookie_data}`;
						}
					}
					return config;
				},
				(error) => {
					return Promise.reject(error);
				}
			);

			axios.interceptors.response.use(
				(response) => {
					return response;
				},
				async (error) => {
					console.log(error);
					if (error.config && util.checkDomain(error.config.url)) {
						// Check if the response code is 401, 403, or 420
						if (typeof error.response !== "undefined") {
							if (typeof error.response.status !== "undefined") {
								if (
									[401, 403, 420].includes(
										error.response.status
									)
								) {
									// Check if there is a refresh_token cookie
									const refreshToken =
										Cookies.get("refresh_token");
									if (refreshToken) {
										try {
											// Fetch the API URL to refresh the JWT and refresh token
											const refreshedTokens =
												await axios.post(
													`${util.api.url()}/token/refresh`,
													{ refreshToken }
												);
											// Update the access token and refresh token in your application
											Cookies.set(
												"jwt",
												refreshedTokens.jwt,
												{ expires: 15 }
											);
											Cookies.set(
												"refresh_token",
												refreshedTokens.refresh_token,
												{ expires: 90 }
											);
											Cookies.set(
												"auth_token",
												refreshedTokens.auth_token,
												{ expires: 30 }
											);
											// Retry the original request with the updated tokens
											const retryConfig = error.config;
											retryConfig.headers[
												"Authorization"
											] = `Bearer ${refreshedTokens.data.jwt}`;
											retryConfig.headers["tf-token"] =
												refreshedTokens.data.auth_token;
											return axios(retryConfig);
										} catch (refreshError) {
											//user is unable to be authenticated. log them out
											Cookies.remove("auth_token");
											Cookies.remove("jwt");
											Cookies.remove("refresh_token");
											//retry without authentication?
										}
									}
								}
							}
						}
					}
					return Promise.reject(error);
				}
			);
		}

		function updateRequestURLs() {
			axios.interceptors.request.use(function (config) {
				if (config.url.includes("force=true")) {
					return config;
				}
				let origin = location.origin;
				let urlObject = new URL(config.url);
				let target = urlObject.origin;
				console.log(origin, target);

				if (origin.includes("localhost")) {
					if (target.includes("api.tfs.services")) {
						config.url = config.url.replace(
							target,
							"http://localhost:8082"
						);
					}
					if (target.includes("/truefire.com")) {
						config.url = config.url.replace(
							target,
							"https://dev.truefire.com"
						);
					}
				}

				if (origin.includes("dev.")) {
					if (target.includes("api.tfs.services")) {
						config.url = config.url.replace(
							target,
							"http://localhost:8082"
						);
					}
					if (target.includes("/truefire.com")) {
						config.url = config.url.replace(
							target,
							"https://dev.truefire.com"
						);
					}
					if (target.includes("/jamplay.com")) {
						config.url = config.url.replace(
							target,
							"https://dev.jamplay.com"
						);
					}
				}

				if (origin.includes("staging.")) {
					if (target.includes("api.tfs.services")) {
						config.url = config.url.replace(
							target,
							"https://api-staging.truefire.com"
						);
					}
					if (target.includes("/truefire.com")) {
						config.url = config.url.replace(
							target,
							"https://staging.truefire.com"
						);
					}
				}

				if (origin.includes("qa.")) {
					if (target.includes("api.tfs.services")) {
						config.url = config.url.replace(
							target,
							"https://api-staging.truefire.com"
						);
					}
					if (target.includes("/truefire.com")) {
						config.url = config.url.replace(
							target,
							"https://qa.truefire.com"
						);
					}
				}

				// Production: rewrite api.tfs.services to ECS endpoint
				if (target.includes("api.tfs.services")) {
					config.url = config.url.replace(
						target,
						"https://api-production.truefire.com"
					);
				}

				console.log(config.url);
				return config;
			});
		}

		function doNexus() {
			axios.interceptors.request.use(function (config) {
				let name = "auth_token";
				let value = Cookies.get("auth_token");
				if (!value) {
					return config;
				}
				if (!config.url.includes("api/eq/nexus")) {
					return config;
				}
				// Check if the URL already has a query string
				if (!config.url.includes("?")) {
					// Append query string with name=value to the URL
					config.url += `/?${name}=${value}`;
				} else {
					// Check if the name already exists in the query string
					if (!config.url.includes(`${name}=`)) {
						// Append query string with &name=value to the URL
						config.url += `&${name}=${value}`;
					}
				}

				return config;
			});
		}

		function doGTMPush() {
			axios.interceptors.response.use(
				(response) => {
					if (typeof response === "undefined") return response;
					if (typeof response.headers === "undefined")
						return response;
					if (typeof response.headers["gtm-push"] !== "undefined") {
						console.log("GTM-PUSH HEADER FOUND");
						try {
							let gtmData = JSON.parse(
								atob(response.headers["gtm-push"])
							);
							util.gtm.push(gtmData);
						} catch (error) {
							util.error.report(error);
						}
					}
					return response;
				},
				(error) => {
					return Promise.reject(error);
				}
			);
		}

		function doActionsPush() {

			function doRedirect(data) {
				window.location.href = data.url;
			}

			function showMessageBox(data) {
				alert(data.message);
			}

			axios.interceptors.response.use(
				(response) => {
					if (typeof response === "undefined") return response;
					if (typeof response.headers === "undefined")
						return response;
					if (!util.checkDomain(response.config.url)) return response;
					if (
						typeof response.headers["actions-push"] !== "undefined"
					) {
						try {
							let actions = JSON.parse(
								atob(response.headers["actions-push"])
							);
							if(actions.length){
								actions.forEach((action) => {
									switch (action.type) {
										case "redirect":
											doRedirect(action);
											break;
									}
								});
							}


						} catch (error) {
							util.error.report(error);
						}
					}
					return response;
				},
				(error) => {
					return Promise.reject(error);
				}
			);
		}

		function doCookiePush() {
			function calculateDaysFromDate(targetDateStr) {
				// Specify the target date
				var targetDate = new Date(targetDateStr);

				// Get the current date
				var currentDate = new Date();

				// Calculate the time difference in milliseconds
				var timeDiff = targetDate.getTime() - currentDate.getTime();

				// Convert the time difference to days
				var daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

				return daysDiff;
			}

			function getRootDomain() {
				var domainParts = window.location.hostname.split(".");
				if (domainParts.length > 2) {
					domainParts.shift();
				}
				return domainParts.join(".");
			}

			axios.interceptors.response.use(
				(response) => {
					if (typeof response === "undefined") return response;
					if (typeof response.headers === "undefined")
						return response;
					if (!util.checkDomain(response.config.url)) return response;
					if (
						typeof response.headers["cookie-push"] !== "undefined"
					) {
						try {
							let cookieData = JSON.parse(
								atob(response.headers["cookie-push"])
							);
							window.dataLayer = window.dataLayer || [];
							if (cookieData.length) {
								cookieData.forEach((data, index) => {
									let $expires = data.expires
										? calculateDaysFromDate(data.expires)
										: 1;
									if ($expires < 1) {
										Cookies.remove(data.name);
										localStorage.removeItem(data.name);
									} else {
										Cookies.set(data.name, data.value, {
											expires: $expires,
											domain: getRootDomain(),
										});
										localStorage.setItem(
											data.name,
											data.value
										);
									}
								});
							}
						} catch (error) {
							util.error.report(error);
						}
					}
					return response;
				},
				(error) => {
					return Promise.reject(error);
				}
			);
		}

		function doAlertsPush() {
			//TODO
		}

		function configAxios() {
			axios.interceptors.request.use((config) => {
				if (util.checkDomain(config.url)) {
					config.headers["Content-Type"] = "application/json";
					config.headers["Accept"] = "application/json";
					config.headers["Access-Control-Allow-Origin"] = "*";
					config.headers["Access-Control-Allow-Headers"] = "*";
				}
				return config;
			});
		}

		function addCookieToHeader(cookieName, headerName) {
			axios.interceptors.request.use(
				(config) => {
					if (util.checkDomain(config.url)) {
						let cookie_data = Cookies.get(cookieName);
						if (cookie_data) {
							config.headers[headerName] = cookie_data;
						} else {
							//try local storage
							cookie_data = localStorage.getItem(cookieName);
							if (cookie_data) {
								config.headers[headerName] = cookie_data;
							}
						}
					}
					return config;
				},
				(error) => {
					console.log("addCookieToHeader-error", error);
					return Promise.reject(error);
				}
			);
		}

		initAxios();
	}

	dojQuery() {
		let util = tfs.util;
		function initJquery() {
			$.ajaxSetup({
				beforeSend(xhr, settings) {
					settings = doNexus(xhr, settings);
					if (util.checkDomain(settings.url)) {
						xhr.setRequestHeader("Accept", "application/json");
						let cookie_data = Cookies.get("jwt");
						if (cookie_data) {
							xhr.setRequestHeader(
								"Authorization",
								"Bearer " + cookie_data
							);
						}
						xhr = addCookieToHeader("auth_token", "tf-token", xhr);
						xhr = addCookieToHeader(
							"server_auth_token",
							"tf-token",
							xhr
						);
						xhr = addCookieToHeader(
							"tfs_auth_token",
							"tf-token",
							xhr
						);
						xhr = addCookieToHeader(
							"hubspotutk",
							"hubspotutk",
							xhr
						);
					}
					// settings = updateRequestURLs(settings)
				},
				complete(xhr) {
					doCookiePush(xhr);
					doGTMPush(xhr);
					doJWT(xhr);
				},
			});
		}

		function updateRequestURLs(settings) {
			if (settings.url.includes("force=true")) {
				return settings;
			}
			let origin = location.origin;
			let urlObject = new URL(settings.url);
			let target = urlObject.origin;
			console.log("origin, target", origin, target);

			if (origin.includes("localhost")) {
				if (target.includes("api.tfs.services")) {
					settings.url = settings.url.replace(
						target,
						"http://localhost:8082"
					);
				}
				if (target.includes("/truefire.com")) {
					settings.url = settings.url.replace(
						target,
						"https://dev.truefire.com"
					);
				}
			}

			if (origin.includes("dev.truefire.com")) {
				if (target.includes("api.tfs.services")) {
					settings.url = settings.url.replace(
						target,
						"http://localhost:8082"
					);
				}
				if (target.includes("/truefire.com")) {
					settings.url = settings.url.replace(
						target,
						"https://dev.truefire.com"
					);
				}
			}

			if (origin.includes("staging.truefire.com")) {
				if (target.includes("api.tfs.services")) {
					settings.url = settings.url.replace(
						target,
						"https://api-staging.truefire.com"
					);
				}
				if (target.includes("/truefire.com")) {
					settings.url = settings.url.replace(
						target,
						"https://staging.truefire.com"
					);
				}
			}

			if (origin.includes("qa.truefire.com")) {
				if (target.includes("api.tfs.services")) {
					settings.url = settings.url.replace(
						target,
						"https://api-staging.truefire.com"
					);
				}
				if (target.includes("/truefire.com")) {
					settings.url = settings.url.replace(
						target,
						"https://qa.truefire.com"
					);
				}
			}

			// Production: rewrite api.tfs.services to ECS endpoint
			if (target.includes("api.tfs.services")) {
				settings.url = settings.url.replace(
					target,
					"https://api-production.truefire.com"
				);
			}

			return settings;
		}

		function doJWT(xhr) {
			if ([401, 403, 420].includes(xhr.status)) {
				// Check if there is a refresh_token cookie
				const refreshToken = Cookies.get("refresh_token");
				if (refreshToken) {
					try {
						// Fetch the API URL to refresh the JWT and refresh token
						$.ajax({
							url: util.api.url() + "/token/refresh",
							method: "POST",
							data: { refreshToken },
							success: function (refreshedTokens) {
								// Update the access token and refresh token in your application
								Cookies.set("jwt", refreshedTokens.jwt, {
									expires: 15,
								});
								Cookies.set(
									"refresh_token",
									refreshedTokens.refresh_token,
									{ expires: 90 }
								);
								Cookies.set(
									"auth_token",
									refreshedTokens.auth_token,
									{ expires: 30 }
								);
								// Retry the original request with the updated tokens
								const retryConfig = xhr;
								retryConfig.setRequestHeader(
									"Authorization",
									"Bearer " + refreshedTokens.jwt
								);
								retryConfig.setRequestHeader(
									"tf-token",
									refreshedTokens.auth_token
								);
								// $.ajax(retryConfig);
							},
							error: function (refreshError) {
								// User is unable to be authenticated. Log them out
								Cookies.remove("auth_token");
								Cookies.remove("jwt");
								Cookies.remove("refresh_token");
								// Retry without authentication?
							},
						});
					} catch (error) {
						util.error.report(error);
					}
				}
			}
		}

		function doNexus(xhr, settings) {
			let name = "auth_token";
			let value = Cookies.get("auth_token");
			if (!value) {
				return settings;
			}
			if (!settings.url.includes("api/eq/nexus")) {
				return settings;
			}
			// Check if the URL already has a query string
			if (!settings.url.includes("?")) {
				// Append query string with name=value to the URL
				settings.url += `/?${name}=${value}`;
			} else {
				// Check if the name already exists in the query string
				if (!settings.url.includes(`${name}=`)) {
					// Append query string with &name=value to the URL
					settings.url += `&${name}=${value}`;
				}
			}
			return settings;
		}

		function addCookieToHeader(cookieName, headerName, xhr) {
			function getRootDomain() {
				var domainParts = window.location.hostname.split(".");
				if (domainParts.length > 2) {
					domainParts.shift();
				}
				return domainParts.join(".");
			}

			let cookie_data = Cookies.get(cookieName);
			if (cookie_data) {
				xhr.setRequestHeader(headerName, cookie_data);
			} else {
				//try local storage
				cookie_data = localStorage.getItem(cookieName);
				if (cookie_data) {
					Cookies.set(cookieName, cookie_data, {
						expires: 30,
						domain: getRootDomain(),
					});
					xhr.setRequestHeader(headerName, cookie_data);
				}
			}
			return xhr;
		}

		function doCookiePush(xhr) {
			console.log(xhr);

			function calculateDaysFromDate(targetDateStr) {
				// Specify the target date
				var targetDate = new Date(targetDateStr);

				// Get the current date
				var currentDate = new Date();

				// Calculate the time difference in milliseconds
				var timeDiff = targetDate.getTime() - currentDate.getTime();

				// Convert the time difference to days
				var daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

				return daysDiff;
			}

			if (xhr.getResponseHeader("Cookie-Push")) {
				try {
					let cookieData = JSON.parse(
						atob(xhr.getResponseHeader("Cookie-Push"))
					);
					if (cookieData.length) {
						$.each(cookieData, function (index, data) {
							let $expires = data.expires
								? calculateDaysFromDate(data.expires)
								: 1;
							if ($expires < 1) {
								Cookies.remove(data.name);
							} else {
								Cookies.set(data.name, data.value, {
									expires: $expires,
								});
							}
						});
					} else {
						// Handle empty cookieData array
					}
				} catch (error) {
					util.error.report(error);
				}
			}
		}

		function doGTMPush(xhr) {
			if (xhr.getResponseHeader("GTM-Push")) {
				try {
					let gtmData = JSON.parse(
						atob(xhr.getResponseHeader("GTM-Push"))
					);
					util.gtm.push(gtmData);
				} catch (error) {
					util.error.report(error);
				}
			}
		}

		initJquery();
	}
}

const $tfs = new TFSUtils();
document.addEventListener("DOMContentLoaded", function () {
	$tfs.doPartnerNonceAuthentication();
});